import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-radio-btn',
  imports: [ReactiveFormsModule, MatFormFieldModule, MatRadioModule, MatInputModule, FormsModule],
  templateUrl: './radio-btn.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './radio-btn.component.scss'
})
export class RadioBtnComponent {
  @Input() options = [
    { value: '', viewValue: '' },
  ];
  @Input() label = '';
  @Input() value = this.options[0].value;
  @Input() inputFormControl: FormControl | null = null;
  @Input() disabled: boolean = false;

  @Output() onChange = new EventEmitter();
  formControl = new FormControl(this.value);

  public ngOnInit() {
    if (this.inputFormControl) {
      this.formControl = this.inputFormControl;
      // If FormControl has no value or empty string, set to first option
      if (this.formControl.value === undefined || this.formControl.value === null || this.formControl.value === '') {
        this.formControl.setValue(this.options[0].value);
      }
    } else if (this.options.length) {
      this.formControl.setValue(this.options[0].value);
    }

    this.formControl.valueChanges.subscribe(change => {
      this.onChange.emit(this.formControl);
    });
  }
}
